import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getUserDecision } from "../decision";
import { isCrawler } from "../utils";
/**
 * Is the current request from a spider / crawler?
 */

var preDecisionGatewayIsCrawler = function preDecisionGatewayIsCrawler(resultIfBot) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var decisionCookieName;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              decisionCookieName = _ref.decisionCookieName;

              if (!(getUserDecision(decisionCookieName) !== false || !resultIfBot)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              return _context.abrupt("return", isCrawler() ? resultIfBot : false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export { preDecisionGatewayIsCrawler };